export default __webpack_public_path__ + "static/media/logo-viacredi.1572b281.png";